import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    all: [],
    single: null,
    owners: [],
    addressTypes: [],
    metaDataColumns: null,
    metaDataFields: null
  },
  actions,
  getters,
  mutations
}
